export const AdminVeloFriendlyMapHook: {
  el?: HTMLElement
  abortController?: AbortController
  mounted: () => void
  destroyed: () => void
  unMountComponent?: (() => void) | undefined
  isDestroyed?: boolean
} = {
  mounted() {
    if (!this.el) {
      return
    }

    const rootElement = this.el

    void import('../../react/views/AdminVeloFriendlyMapView')
      .then(({ AdminVeloFriendlyMapView }) => {
        if (this.isDestroyed) {
          return
        }

        this.unMountComponent = AdminVeloFriendlyMapView({ rootElement, liveView: this })
      })
      .catch((error) => {
        console.error('[AdminVeloFriendlyMapHook] Failed to load map view:', error)
      })
  },
  destroyed() {
    this.isDestroyed = true
    this.unMountComponent?.()
  },
}
